import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SharedViewer } from "../../features/viewer/components/shared-viewer";

/** FR-COL-03, FR-COL-04: public, read-only; ?t=84 starts the replay there. */
export const Route = createFileRoute("/share/$token")({
  validateSearch: z.object({ t: z.coerce.number().int().min(0).optional().catch(undefined) }),
  component: () => (
    <SharedViewer token={Route.useParams().token} startSeconds={Route.useSearch().t} />
  ),
});
